module.exports = __webpack_public_path__ + "img/10n@2x.a2ad31f8.svg";